import { LOCALIZED } from '@libs/core/constants';

import { type Personalization } from '@/entities/product';
import type { FormFields } from '@/entities/purchase-form';

import { buildLineLabel } from './build-line-label';
import { buildLineText } from './build-line-text';

type GetSthData = {
    productDataPersonalization?: Personalization;
    formDataPersonalization?: Pick<
        FormFields['personalization'],
        'frontLines' | 'backLines' | 'fontFace' | 'colorStyle'
    >;
    purchaseOption?: FormFields['purchaseOption'];
};

export const getSthData = ({ productDataPersonalization, formDataPersonalization, purchaseOption }: GetSthData) => {
    const customizationType = productDataPersonalization?.customizationType || 'Engraved';

    // Lines
    const frontLinesText = buildLineText({ lines: formDataPersonalization?.frontLines });
    const backLinesText = buildLineText({ lines: formDataPersonalization?.backLines });
    const customizationVasText = [frontLinesText, backLinesText].filter(Boolean).join('|');

    // Labels
    const frontLineLabels = buildLineLabel({
        name: 'FRONT',
        type: customizationType,
        lines: formDataPersonalization?.frontLines,
    });

    const backLineLabels = buildLineLabel({
        name: 'BACK',
        type: customizationType,
        lines: formDataPersonalization?.backLines,
    });

    const customizationVasTextLabel = [frontLineLabels, backLineLabels].filter(Boolean).join('|');

    const withPersonalization = {
        customizationVasAmount: 0,
        customizationVasType: customizationType,
        customizationStyle: formDataPersonalization?.colorStyle || '',
        customizationFontName: formDataPersonalization?.fontFace || '',
        customizationVasID: productDataPersonalization?.templateId || '0',
        customizationVasText: `|${customizationVasText}|`,
        customizationVasTextLabel: `|${customizationVasTextLabel}|`,
    };

    if (purchaseOption === 'autoship') return {};

    const baseData = {
        storeId: LOCALIZED.webInventory,
    };

    return productDataPersonalization ? withPersonalization : baseData;
};
